import React, { forwardRef, useState } from "react";
import {
  Container,
  Header,
  Content,
  Sidebar as Side,
} from "rsuite";
import { Icon, Segment } from "semantic-ui-react";
import { api } from "../../services/api";
import moment from "moment";
import {
  ArrowDownward,
  ChevronLeft,
  ChevronRight,
  Clear,
  FilterList,
  FirstPage,
  LastPage,
  Search,
} from "@material-ui/icons";
import MaterialTable from "material-table";
import Navbarr from "../../components/Navbar";

import "./styles.css";

export default function LogsList({ sidebar: Sidebar }) {
  const [isLoading, setIsLoading] = useState(false);
  const [lastUpdate, setLastUpdate] = useState("...");

  const columns = [
    {
      title: "Identificador",
      // sorting: true,
      field: "id",
      // sort: "desc",
      width: 50,
      // editable: "never",
      // type: "numeric",
      // align: "center",
      filtering: false,
    },
    {
      title: "Usuário",
      sorting: true,
      field: "usuario",
      //sort: 'asc',
      width: 300,
      // editable: "never",
      // align: "left",
    },
    {
      title: "Ação",
      sorting: true,
      field: "acao",
      //sort: 'asc',
      width: 300,
      // editable: "never",
      // align: "left",
    },
    {
      title: "Data",
      sorting: true,
      field: "data",
      //sort: 'asc',
      width: 300,
      // editable: "never",
      // align: "left",
      type: "date",
    },
    {
      title: "Status",
      sorting: true,
      field: "status",
      //sort: 'asc',
      width: 300,
      // editable: "never",
      // align: "left",
    },
    {
      title: "Descrição",
      sorting: true,
      field: "descricao",
      //sort: 'asc',
      width: 300,
      // editable: "never",
      // align: "left",
    },
  ];

  const tableIcons = {
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
  };

  const dataQuery = async (query) => {
    console.log("Query", query);

    let filtersArray = [];

    if (query.filters.length > 0) {
      filtersArray = query.filters.map((filter) => {
        return { field: filter.column.field, value: filter.value };
      });
    }

    // se existir o campo data na query, transforma em uma string
    for (let filter of filtersArray) {
      if (filter.field === "data") {
        filter.value = moment(filter.value).format("YYYY-MM-DD");
      }
    }

    return new Promise(async (resolve, reject) => {
      setIsLoading(true);
      try {
        const { content, pageable, ...pageData } = await api.getLogs(
          query.page,
          query.pageSize,
          query.orderBy === undefined ? "data" : query.orderBy.field,
          query.orderDirection === undefined ? "desc" : query.orderDirection,
          filtersArray
        );
        setLastUpdate(moment().subtract({ hours: 3 }).format("LT")); // Subtract 3 hours to show correctly for GMT-3
        content.forEach(changeLogForTable);
        return resolve({
          data: content, // your data array
          page: pageable.pageNumber, // current page number
          totalCount: pageData.totalElements, // total row number
        });
      } catch (err) {
        return reject(err);
      } finally {
        setIsLoading(false);
      }
    });
  };

  const changeLogForTable = (log) => {
    // log["id"] já é o id
    log["usuario"] = log["usuario"] ? log["usuario"]["nome"] : "Sem usuário";
    // log["acao"] já é a ação
    log["data"] = moment(log["data"]).format("DD/MM/YYYY HH:mm:ss");
    // log["status"] já é o status
    // log["descricao"] já é a descrição
    return log;
  };

  return (
    <Container>
      <Side style={{ flex: "0 0 auto", width: "auto" }}>
        <Sidebar page={""}></Sidebar>
      </Side>
      <Container>
        <Header>
          <Navbarr />
        </Header>
        <Content style={{ backgroundColor: "#FAFAFA", padding: "5px" }}>
          <Segment>
            <MaterialTable
              title="Logs de sistema"
              style={{
                backgroundColor: "none",
                boxShadow: "none",
                padding: 0,
                margin: 0,
              }}
              columns={columns}
              data={dataQuery}
              icons={tableIcons}
              isLoading={isLoading}
              options={{
                pageSize: 20,
                pageSizeOptions: [5, 10, 20, 50],
                search: false,
                sorting: true,
                filtering: true,
                draggable: false,
                actionsColumnIndex: -1,
                headerStyle: {
                  backgroundColor: "#f2f2f2",
                  color: "#000",
                  fontSize: "12px",
                },
                rowStyle: {
                  fontSize: "12px",
                },
              }}
            />
          </Segment>
        </Content>
        <Segment.Inline
          style={{
            fontSize: "12px",
            color: "#b0b0b0",
            marginRight: "10px",
            marginLeft: "10px",
          }}
        >
          <Icon name="clock outline" />
          Atualizado em {lastUpdate}
        </Segment.Inline>
      </Container>
    </Container>
  );
}
